/**
 * The Bot chip menu's Show decisions switch (acqs/_bot_chips.html, `[data-show-bot-decisions]`).
 *
 * Off hides the seller bot's decisions, quiet groups, escalation notes and the why button on a bot-sent text
 * (`[data-bot-detail]`) in every lead SMS timeline on the page (`[data-lead-timeline]`: the SMS sheet and the
 * lead page's SMS panel).  Texts, calls and draft cards stay.  The choice is saved in localStorage, one setting
 * for every lead, and every switch on the page (and in other tabs) follows it.  A page with no switch shows everything.
 *
 * A date divider (`.chat-log__divider`) is markup on its day's first entry, so hiding that entry would take the
 * date off the day's texts.  After each change the divider moves above its day's first visible entry, and hides
 * when the day has none, and goes back to its own day when the switch turns on.  A thread of only bot entries
 * shows its `data-bot-only-empty` note while they are hidden.  The decision a Bot decisions row opened the sheet at
 * (`data-focus-decision`) stays shown.
 *
 * Timelines arrive by htmx swaps and by acqs-ws.js's own outerHTML swaps, which fire no htmx:load, so a
 * MutationObserver applies the setting to new content before it paints.  An htmx swap then settles: entries that
 * keep their id (`bot-decision-<pk>-<timeline>`) get their response attributes back, class included, so the setting is
 * applied again on htmx:afterSettle.
 */

(function () {
    if (window.__acqsBotDecisionsBound) return;
    window.__acqsBotDecisionsBound = true;

    var STORAGE_KEY = 'acqs-show-bot-decisions';
    var WATCHED = '[data-lead-timeline], [data-conversation-timeline], .chat-log, [data-show-bot-decisions]';

    // Off only hides where the page also has a switch to turn it back on: a prospect, or a lead with no run, has no
    // Bot chip, so its timeline always shows everything.
    function decisionsShown() {
        if (!document.querySelector('[data-show-bot-decisions]')) return true;
        try { return localStorage.getItem(STORAGE_KEY) !== '0'; } catch (e) { return true; }
    }

    // Each divider remembers the entry it was rendered above (`_acqsDayStart`), so a day is that entry up to the
    // next day's, wherever the dividers sit now, and On puts every divider back above its own day's first entry.
    function placeDividers(log, isHidden) {
        var dayByStart = new Map();
        log.querySelectorAll(':scope > .chat-log__divider').forEach(function (divider) {
            if (!divider._acqsDayStart) divider._acqsDayStart = divider.nextElementSibling;
            if (divider._acqsDayStart) dayByStart.set(divider._acqsDayStart, { divider: divider, entries: [] });
        });
        var day = null;
        Array.prototype.forEach.call(log.children, function (child) {
            if (child.classList.contains('chat-log__divider')) return;
            day = dayByStart.get(child) || day;
            if (day) day.entries.push(child);
        });
        dayByStart.forEach(function (d) {
            var target = d.entries.find(function (entry) { return !isHidden(entry); });
            d.divider.classList.toggle('d-none', !target);
            if (target && d.divider.nextElementSibling !== target) log.insertBefore(d.divider, target);
        });
    }

    function apply() {
        var shown = decisionsShown();
        document.querySelectorAll('[data-lead-timeline]').forEach(function (root) {
            // A Bot decisions row opened this timeline at one decision: that one stays in view.
            var focus = root.querySelector('[data-focus-decision]');
            var focusRow = focus ? '[data-decision-row="' + focus.getAttribute('data-focus-decision') + '"]' : null;
            var isHidden = function (el) {
                return !shown && el.matches('[data-bot-detail]')
                    && !(focusRow && (el.matches(focusRow) || el.querySelector(focusRow)));
            };
            root.querySelectorAll('[data-bot-detail]').forEach(function (el) {
                el.classList.toggle('d-none', isHidden(el));
            });
            root.querySelectorAll('.chat-log').forEach(function (log) {
                placeDividers(log, isHidden);
                var empty = log.parentElement.querySelector(':scope > [data-bot-only-empty]');
                if (empty) {
                    empty.hidden = Array.prototype.some.call(log.children, function (child) {
                        return !child.classList.contains('chat-log__divider') && !isHidden(child);
                    });
                }
            });
        });
        document.querySelectorAll('[data-show-bot-decisions]').forEach(function (input) {
            input.checked = shown;
        });
    }

    // Another tab changed the setting.
    window.addEventListener('storage', function (event) {
        if (event.key === STORAGE_KEY) apply();
    });

    document.addEventListener('change', function (event) {
        if (!event.target.matches('[data-show-bot-decisions]')) return;
        try { localStorage.setItem(STORAGE_KEY, event.target.checked ? '1' : '0'); } catch (e) { /* private mode */ }
        apply();
    });

    function addsWatched(mutations) {
        return mutations.some(function (mutation) {
            return Array.prototype.some.call(mutation.addedNodes, function (node) {
                return node.nodeType === 1 && (node.matches(WATCHED) || node.querySelector(WATCHED));
            });
        });
    }

    new MutationObserver(function (mutations) {
        if (addsWatched(mutations)) apply();
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('htmx:afterSettle', function (event) {
        if (event.target.closest('[data-lead-timeline]') || event.target.querySelector('[data-lead-timeline]')) apply();
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
    else apply();
})();
